<template>
  <b-modal id="delete-error-modal" hide-footer centered @show="textarea = ''">
    <template #modal-header="{ close }">
      <div class="d-flex justify-content-between w-100 align-items-center">
        <h5 class="mb-0" style="color: #FF0000; font-weight: bold">Hủy lỗi mã {{currentError}}</h5>
      </div>
    </template>
    <ValidationObserver v-slot="{ handleSubmit }" ref="form">
      <form class="form" autocomplete="off">

        <p style="color: #FF0000">Dữ liệu sau khi hủy sẽ không thể khôi phục được.</p>
        <p>Vui lòng nhập lí do hủy lỗi:</p>
        <ValidationProvider name="Lý do hủy tác vụ" rules="required|max:30"
                            v-slot="{ errors,classes }"
                            vid="cancel_reason">
          <el-input
              type="textarea"
              :rows="2"
              placeholder="Nhập lí do hủy tác vụ"
              v-model="textarea">
          </el-input>
          <div class="fv-plugins-message-container">
            <div data-field="name" data-validator="notEmpty" class="fv-help-block">
              {{ errors[0] }}
            </div>
          </div>
        </ValidationProvider>
        <div class="d-flex justify-content-end mt-2 ">
          <button type="button" class="btn btn-secondary mr-2" style="width: 100px" @click="close" :disabled="loading">Đóng</button>
          <button type="button" class="btn btn-danger" style="min-width: 100px" @click="handleSubmit(cancelTask)" :disabled="loading"><i v-if="loading" class="el-icon-loading"></i>Hủy tác vụ</button>
        </div>
      </form>
    </ValidationObserver>
  </b-modal>
</template>
<script>
import {CANCEL_ERROR} from "../../../../core/services/store/report-error/reportError.module";

export default {
  name: "DeleteErrorModal",
  props:{
    currentError:{
      type: Number,
      default: null
    }
  },
  data() {
    return {
      textarea: '',
      loading: false
    }
  },
  methods:{
    close(){
      this.$bvModal.hide('delete-error-modal')
    },
   async cancelTask(){
      this.loading = true
      try {
        await this.$store.dispatch(CANCEL_ERROR, {id:this.currentError,payload:{cancel_reason: this.textarea}})
        this.$notify({
          title: 'Success',
          message: 'Hủy lỗi thành công',
          type: 'success'
        });
        this.$emit('getListError')
        this.$bvModal.hide('delete-error-modal')
      }catch (e) {
        this.$notify.error({
          title: 'Error',
          message: 'Đã có lỗi xẩy ra'
        });
      }finally {
        this.loading = false
      }

    }
  }
}
</script>

<style scoped>

</style>